import { gitHubEmojis } from '@tiptap/extension-emoji';

/**
 * Filtered list of GitHub emojis excluding regional indicator symbols
 */
export const EMOJIS = gitHubEmojis.filter((emoji) => !emoji.name.includes('regional'));
